import { QuestionReviewTaskCreationHeader } from '@exam-management/new-question-review-task-creation';
import {
  PermissionRouteGuard,
  type PermissionRouteGuardData,
} from '@exam-management/permission-route-guard';
import { APP_PERMISSIONS } from '@exam-management/permissions';
import { Outlet } from 'react-router-dom';

export default function QuestionReviewTaskCreationLayout() {
  const defaultRoutes: PermissionRouteGuardData[] = [
    {
      path: '/task-management/question-review/create',
      requiredPermission: [APP_PERMISSIONS.TASK.QUESTION_REVIEW.CREATE],
    },
  ];
  return (
    <PermissionRouteGuard routes={defaultRoutes}>
      <QuestionReviewTaskCreationHeader />
      <Outlet />
    </PermissionRouteGuard>
  );
}
